import React, { Component, Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import { ArrowBackOutlined, LocalHospitalOutlined } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

class EditModeOptions extends Component {
  state = { searchKey: "" };

  render() {
    var props = this.props;
    return (
      <Fragment>
        <div className={`search-in-card-wrapper${props.isNotEditMode ? "" : " hide"}`}>
          <div className="inline-block">
            <TextField
              label="חיפוש"
              value={this.state.searchKey}
              onChange={this.handleChange}
              className="field-strech"
              id="searchKey"
              onKeyPress={this.handleKeyPress}
            />
          </div>
          <div className="search-icon-wrapper">
            <i onClick={this.redirectToUsersSearch} className="material-icons primary-color">
              search
            </i>
          </div>
        </div>
        <div className="edit-mode-wrapper">
          <div className="inline-block">
            <div className="inline-block ml-10">
              <button onClick={props.toggleBookKeepingMode}>{props.isBookKeepingView ? <span>כרטיס</span> : <span>הנה"ח</span>}</button>
            </div>
            <button onClick={props.toggleEditMode}>{props.isNotEditMode ? <span>עריכה</span> : <span> ביטול</span>}</button>
          </div>

          <div className={`save-wrapper ${props.isNotEditMode ? "hide" : ""}`}>
            {props.isAllowedEditsInPopup ? (
              <i onClick={props.deleteUserCard} className="material-icons delete-icon">
                delete
              </i>
            ) : null}

            <i onClick={props.saveUserChanges} className="material-icons save-icon">
              check
            </i>
          </div>

          <div className="support-btn">
            <IconButton onClick={props.toggleSupportPopup}>
              {props.isSupportPopupOpen ? <ArrowBackOutlined /> : <LocalHospitalOutlined />}
            </IconButton>
          </div>
        </div>
      </Fragment>
    );
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") this.redirectToUsersSearch();
  };

  redirectToUsersSearch = () => {
    if (!this.state.searchKey) return;
    if (this.state.searchKey.length < 3) {
      if (isNaN(this.state.searchKey)) {
        return;
      }
    }

    this.props.history.push("/admin/users-manager/" + this.state.searchKey.trim());
  };
}

export default EditModeOptions;
